import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiCard, EuiSteps, EuiInMemoryTable} from '@elastic/eui';
import { Header } from './components/header';
import { Footer } from './components/footer';
import styled from 'styled-components';

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;


class Education extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            attributes: [],
            courses: [],
            attRows: [],
            engCourses: [],
            AlertText: "",
            AlertType: "error",
            skills: ["Deep learning", "Data Analysis", "Research Machine", "Learning Innovation", "Rational     Analytics", "Multi-Disciplinary", "CNN", "AI", "Computer vision"],
            shortTerm: ['MS - Data Science', 'Scholarships & Fellowships', 'Research Experience'],
            midTerm: ['Applied Research', 'Innovations', 'Industry Experience'],
            longTerm: ['Impactful Technocrat', 'Radical Technologies', 'Entrepreneur'],
            Institution1key:['Teaching and mentoring interested individuals','Mentoring multiple students with ML based projects','Learn and guide for NVIDIA student programs','Coordination of hackathons for Inter- college'],
            Institution1value:['Teaching ','Mentoring', 'Teamwork ','Project building'],
            Institution2key:['Teaching and mentoring interested individuals','Coordination of CTF competitions for Inter-college'],
            Institution2value:['Mentoring and Teamwork','Participation in CTF competitions'],
            Institution3key:['Working on ROBOCON competitions','Learning and debugging firmware coding','Application of theory knowledge into practice','Worked on line follower robot, maze runner robot, etc.'],
            Institution3value:['Team-based group learning','Theory to Practice','Participation in Competitions '],
        }
    }

    componentWillMount() {
      let attributes = [
        {
            field: 'attributes',
            name: <EuiText>Attributes</EuiText>,
            sortable: true,
            truncateText: true,
        },
        {
            field: 'score',
            name: <EuiText>Scores</EuiText>,
            truncateText: true,
        }]
      let courses = [
        {
            field: 'courses',
            name: <EuiText>Structural Engineering Courses</EuiText>,
            truncateText: true,
        }]
      let attRows = [
        {
          id: '1',
          attributes: 'Credits',
          score: 'Σ170'
        },
        {
          id: '2',
          attributes: 'Presentations',
          score: 'Σ25+'
        },
        {
          id: '3',
          attributes: 'Theory Exams',
          score: 'Σ35'
        },
        {
          id: '4',
          attributes: 'Site Visits',
          score: 'Σ10+'
        },
        {
          id: '5',
          attributes: 'Mini Projects',
          score: 'Σ4'
        },
        {
          id: '6',
          attributes: 'Workhops',
          score: 'Σ5'
        },
        {
          id: '7',
          attributes: 'Guest Lectures',
          score: 'Σ40+'
        },
        {
          id: '8',
          attributes: 'Submissions',
          score: 'Σ50+'
        },
      ]
      let engCourses = [
        {id: '1',courses: 'Engineering Mathematics 1'}, {id: '2',courses: 'Engineering Graphics'}, {id: '3',courses: 'Engineering Physics'}, {id: '4',courses: 'Engineering Mechanics'}, {id: '5',courses: 'Strength of Materials'}, {id: '6',courses: 'Engineering Mathematics 2'}, {id: '7',courses: 'Concrete Technology'}, {id: '8',courses: 'Building Materials and Construction'}, {id: '9',courses: 'Theory of Structures'}, {id: '10',courses: 'Geotech Engineering'}, {id: '11',courses: 'Engineering Mathematics 3'}, {id: '12',courses: 'Design of Steel'}, {id: '13',courses: 'Foundation Engineering'}, {id: '14',courses: 'Advanced Concrete Technology'}, {id: '15',courses: 'Design of RCC'},
      ]
      this.setState({
        attributes: attributes,
        courses: courses,
        attRows: attRows,
        engCourses: engCourses
      })
  }


    render() {  
      const workList = [
        { title:'Academic Background',
          children: (
            <EuiCard
                textAlign="left"
                title={<EuiText>Bachelor in Civil Engineering </EuiText>}
                titleSize="s"
                description={<EuiText size='m'> (2018-2022) </EuiText>}>
        <EuiText size="m">
        <ul><StyledText/>
        <li><b>College</b> - Vishwakarma Institute of Information Technology </li>
        <li><b>University</b> - 	Savitribai Phule Pune University (SPPU)</li>
        <li><b>Grade</b> - 8.55GPA</li>
      </ul></EuiText></EuiCard>),
        },
        { title:'Co & Extra-Curricular Activities   ',
        children: (
          <EuiCard textAlign="left">
                <EuiText size="m">
              <ul>
              <li>1)	Site visits: Water Treatment Plant, Pune International Airport, Western Express Highway etc.  </li>
              <li>2)	Participation at State level Sci-Tech competition for mini project Solar Powered Auto walk (prototype). </li>
              <li>3)	Volunteering at International Constro Exhibition in the domain: field assistance and management. </li>
              <li>4)	Attained various seminars like: “Monitoring Real Time Performance of Concrete Using Maturity Meters”, 
                “Challenges in Concrete Technology”, “Explore the Construction Activities in Metro work”, 
                “Business Opportunities in Nano-Housing”,
                “Construction Industry during Post COVID-19”.</li>
              <li>5)	Founder Member of NGO “United Liberal Organisation 2017”.</li>
              <li>6)	Cluster level Basketball Player (HighSchool)</li>
              <li>7)	National level Basketball Player (Junior Year)</li>
              <li>8)	Cluster level player Chess Player (High School)</li>
            </ul>
          </EuiText></EuiCard>),
        },
        {
        title: 'Education Equity',
        children: (
            <EuiCard
            textAlign="left"
            title={<EuiText></EuiText>}
            titleSize="xs"
            description={
                  <EuiFlexGroup><EuiFlexItem>
                    <EuiInMemoryTable items={this.state.attRows} columns={this.state.attributes} />
                  </EuiFlexItem><EuiFlexItem>
                    <EuiInMemoryTable items={this.state.engCourses} columns={this.state.courses} />
                  </EuiFlexItem></EuiFlexGroup>}>
            </EuiCard>
        ),}
        
    ]
    return (
      <>
          <EuiPageTemplate>
              <EuiPageHeader><Header /></EuiPageHeader>
          <EuiFlexGroup gutterSize='xl'>
          <EuiFlexItem>
                  <EuiSpacer />
                  <EuiText><h2><font face='Segoe UI'>Academic Equity</font></h2></EuiText>
                  <EuiSpacer size='m' />
                  <div>         
        <EuiSteps titleSize='xs'
          steps={workList}
        />
      </div>
          </EuiFlexItem>
          </EuiFlexGroup>
      <Footer /></EuiPageTemplate>
      </>
        )
    }
};

export { Education }